// Status padrão para novos orçamentos: "Em Execução"
export const STATUS_EM_EXECUCAO_ID = "783a5f8a-684f-47f1-a700-a64fb6ab0279";
export const STATUS_EM_EXECUCAO_DESC = "Em Execução";
// Status para quando Job é gerado: "Pedido Colocado"
export const STATUS_PEDIDO_COLOCADO_ID = "18ad60ed-258c-425e-8ecf-3f2afe7d9e05";
export const STATUS_PEDIDO_COLOCADO_DESC = "Pedido Colocado";

export const criarFormularioPadrao = () => ({
  id: null,
  code: "",
  // cabeçalho
  contabilizar: false,
  numeroProposta: "",
  origem: "DELTA DUCON",
  revisao: "",
  ultimaRevisao: "",
  dataCriacao: new Date().toISOString().split("T")[0],
  dateGenerate: new Date().toISOString().split("T")[0],
  tipoFaturamento: null,
  tipoDeEquipamento: null,
  tipoDeEquipamentoSigla: "",
  tipoDeEquipamentoDescricao: "",
  job: null,
  jobNome: "",
  // legado / compatibilidade
  numeroSolicitacao: "",
  dataSolicitacao: new Date().toISOString().split("T")[0],
  status: STATUS_EM_EXECUCAO_ID,
  statusDescription: STATUS_EM_EXECUCAO_DESC,
  // cliente
  cliente: null,
  clienteNome: "",
  referenciaCliente: "",
  cliente_referencia: "",
  vendedor: null,
  vendedorNome: "",
  orcamentista: null,
  orcamentistaNome: "",
  contato: null,
  contatoNome: "",
  contatoTecnico: null,
  contatoTecnicoNome: "",
  contatoTecnicoTelefone: "",
  contatoTecnicoCelular: "",
  contatoTecnicoEmail: "",
  email: "",
  telefone: "",
  contatoComercialTelefone: "",
  contatoComercialCelular: "",
  contatoComercialEmail: "",
  // financeiro
  descricao: "",
  observacoes: "",
  prazoResposta: "",
  valorEstimado: "0,00",
  valorDisponivel: "0,00",
  ki: "0,000",
  kidoCusto: "0,00",
  porcentagemPIS: "0,00",
  porcentagemCOFINS: "0,00",
  porcentagemIIS: "0,00",
  porcentagemICMSVenda: "0,00",
  porcentagemIPI: "0,00",
  precoVenda_sIPI_cICMS: "0,00",
  precoVenda_sIPI_sICMS: "0,00",
  precoVenda_cISS: "0,00",
  kv: "0,000",
  // proposta tecnica
  projeto: "",
  dataDespacho: "",
  dataConclusao: "",
  // sub-entidades (gerenciados localmente no pai)
  itens: []
});

export const parseNumero = (valor) => {
  if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;
  if (valor === null || valor === undefined || valor === "") return 0;
  const texto = String(valor).trim();
  const textoNormalizado = texto
    .replace(/\s/g, "")
    .replace(/(\d)\.(?=\d{3}(\D|$))/g, "$1")
    .replace(",", ".");
  const numero = Number(textoNormalizado);
  return Number.isFinite(numero) ? numero : 0;
};

export const formatarNumeroInput = (valor, casas = 2) => {
  const numero = parseNumero(valor);
  return Number(numero).toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas
  });
};

export const formatarKv = (valor) => {
  return Number(valor || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  });
};

export const recalcularCamposPreco = (formulario = {}) => {
  const valorDisponivel = parseNumero(formulario.valorDisponivel);
  const ki = parseNumero(formulario.ki);
  const porcentagemICMSVenda = parseNumero(formulario.porcentagemICMSVenda);
  const precoVendaComIcms = parseNumero(formulario.precoVenda_sIPI_cICMS);

  let precoVendaSemIcms = 0;
  if (porcentagemICMSVenda !== 0) {
    precoVendaSemIcms = precoVendaComIcms - ((porcentagemICMSVenda / 100) * precoVendaComIcms);
  }

  let kiDoCusto = 0;
  if (precoVendaComIcms !== 0 && ki !== 0) {
    kiDoCusto = precoVendaComIcms * ki;
  }

  const kv = kiDoCusto !== 0 ? (valorDisponivel / kiDoCusto) : 0;

  return {
    precoVenda_sIPI_sICMS: Number(precoVendaSemIcms.toFixed(2)),
    kidoCusto: Number(kiDoCusto.toFixed(2)),
    kv: formatarKv(kv)
  };
};

export const normalizaItemSalesOrder = (item = {}, statusDescricaoPorId = {}) => {
  const statusId = typeof item.status === "object" ? item.status?.id : item.status;
  const statusDescription =
    item.statusDescription ||
    item.status?.description ||
    statusDescricaoPorId[statusId] ||
    "Sem status";

  const clienteId =
    typeof item.cliente === "object"
      ? item.cliente?.id
      : item.cliente || item.clienteID || null;

  const contatoId =
    (typeof item.contatoComercial === "object"
      ? item.contatoComercial?.id
      : item.contatoComercial) ||
    (typeof item.contato === "object"
      ? item.contato?.id
      : item.contato) ||
    null;

  const contatoTecnicoId =
    typeof item.contatoTecnico === "object"
      ? item.contatoTecnico?.id
      : item.contatoTecnico || null;

  const valorDisponivel = item.valorDisponivel ?? item.revisoes?.valorDisponivel ?? 0;
  const ki = item.ki ?? item.revisoes?.ki ?? 0;
  const kidoCusto = item.kidoCusto ?? item.revisoes?.kidoCusto ?? 0;
  const porcentagemICMSVenda = item.porcentagemICMSVenda ?? item.revisoes?.porcentagemICMSVenda ?? "0";
  const precoVenda_sIPI_cICMS =
    item.precoVenda_sIPI_cICMS ??
    item.revisoes?.precoVenda_sIPI_cICMS ??
    item._mirror_valor_sIPI_cICMS ??
    0;
  const precoVenda_sIPI_sICMS = item.precoVenda_sIPI_sICMS ?? item.revisoes?.precoVenda_sIPI_sICMS ?? 0;
  const kv = item.kv ?? item.revisoes?.kv ?? "0,000";
  const sigla =
    item._mirror_tipo ||
    (typeof item.sigla === "object"
      ? item.sigla?.descricao || item.sigla?.description || item.sigla?.nome || item.sigla?.name || item.sigla?.codigo
      : item.sigla) ||
    (typeof item.origem === "object"
      ? item.origem?.descricao || item.origem?.description || item.origem?.nome || item.origem?.name || item.origem?.codigo
      : item.origem) ||
    (typeof item._mirror_tipoDeEquipamento === "object"
      ? item._mirror_tipoDeEquipamento?.descricao ||
        item._mirror_tipoDeEquipamento?.description ||
        item._mirror_tipoDeEquipamento?.nome ||
        item._mirror_tipoDeEquipamento?.name ||
        item._mirror_tipoDeEquipamento?.codigo
      : item._mirror_tipoDeEquipamento) ||
    "";

  return {
    ...item,
    id: item.id || item._id || item.code,
    sigla,
    code: item.code || item.codigo || item.numeroSolicitacao || "",
    numeroProposta: item.numeroProposta || item.numeroSolicitacao || item.codigo || item.code || "",
    numeroSolicitacao: item.numeroSolicitacao || item.codigo || item.code || "",
    cliente: clienteId,
    clienteNome: item.clienteNome || item.cliente?.nomeFantasia || item.credorNome || item.customerName || "",
    contato: contatoId,
    contatoComercial: contatoId,
    contatoNome: item.contatoComercialNome || item.contato?.nome || item.contatoComercial?.nome || "",
    contatoTelefone: item.contatoComercialTelefone || item.contato?.telefone || item.contatoComercial?.telefone || "",
    contatoComercialTelefone: item.contatoComercialTelefone || item.contato?.telefone || item.contatoComercial?.telefone || "",
    contatoComercialCelular: item.contatoComercialCelular || item.contato?.celular || item.contatoComercial?.celular || "",
    contatoComercialEmail: item.contatoComercialEmail || item.contato?.email || item.contatoComercial?.email || "",
    contatoTecnico: contatoTecnicoId,
    contatoTecnicoNome: item.contatoTecnicoNome || item.contatoTecnico?.nome || item.contatoTecnicoName || "",
    contatoTecnicoTelefone: item.contatoTecnicoTelefone || item.contatoTecnico?.telefone || "",
    contatoTecnicoCelular: item.contatoTecnicoCelular || item.contatoTecnico?.celular || "",
    contatoTecnicoEmail: item.contatoTecnicoEmail || item.contatoTecnico?.email || "",
    cliente_referencia: item.cliente_referencia || item.referenciaCliente || "",
    referenciaCliente: item.referenciaCliente || item.cliente_referencia || "",
      revisao: item.revisao || "",
      ultimaRevisao: item.ultimaRevisao || "",
      dateGenerate: item.dateGenerate || item.dataGeracao || "",
    contatoEmail: item.contatoComercialEmail || item.contatoComercial?.email || "",
    dataSolicitacao:
      item.dataSolicitacao ||
      item.createdAt ||
      item.dataCadastro ||
      item.dataEmissao ||
      "",
    status: statusId || item.status || null,
    statusDescription,
    valorEstimado:
      Number(
        item.valorEstimado ??
        item._mirror_valor_sIPI_cICMS ??
        item.valor ??
        item.total ??
        0
      ) || 0,
    valorDisponivel,
    ki,
    kidoCusto,
    porcentagemPIS: item.porcentagemPIS ?? "0",
    porcentagemCOFINS: item.porcentagemCOFINS ?? "0",
    porcentagemIIS: item.porcentagemIIS ?? "0",
    porcentagemICMSVenda,
    porcentagemIPI: item.porcentagemIPI ?? "0",
    precoVenda_sIPI_cICMS,
    precoVenda_sIPI_sICMS,
    precoVenda_cISS: item.precoVenda_cISS ?? 0,
    kv,
    projeto: item.projeto || "",
    dataDespacho: item.dataDespacho || "",
    dataConclusao: item.dataConclusao || "",
    _mirror_tipoDeEquipamento: item._mirror_tipoDeEquipamento || "",
    tipoDeEquipamento:
      (typeof item.tipoDeEquipamento === "object" ? item.tipoDeEquipamento?.id : item.tipoDeEquipamento) || null,
    tipoDeEquipamentoSigla:
      item.tipoDeEquipamentoSigla ||
      item.tipoDeEquipamento?.sigla ||
      item.tipoDeEquipamento?.codigo ||
      item.tipoDeEquipamento?.code ||
      "",
    tipoDeEquipamentoDescricao:
      item.tipoDeEquipamentoDescricao ||
      item.tipoDeEquipamento?.descricao ||
      item.tipoDeEquipamento?.nome ||
      item.tipoDeEquipamento?.description ||
      "",
    itens: Array.isArray(item.itens) ? item.itens : []
  };
};

export const normalizaListaSalesOrder = (response, statusDescricaoPorId = {}) => {
  const lista =
    response?.data?.data?.data ||
    response?.data?.data ||
    response?.data ||
    [];

  if (!Array.isArray(lista)) return [];
  return lista.map((item) => normalizaItemSalesOrder(item, statusDescricaoPorId));
};

export const gerarPayloadPersistencia = (formulario = {}) => {
  return {
    ...formulario,
    cliente_referencia: formulario.cliente_referencia || formulario.referenciaCliente || "",
    referenciaCliente: formulario.referenciaCliente || formulario.cliente_referencia || "",
    contatoComercial: formulario.contato || formulario.contatoComercial || null,
    contatoTecnico: formulario.contatoTecnico || null,
    contatoComercialTelefone: formulario.contatoComercialTelefone || formulario.telefone || "",
    contatoComercialCelular: formulario.contatoComercialCelular || "",
    contatoComercialEmail: formulario.contatoComercialEmail || formulario.email || "",
    contatoTecnicoNome: formulario.contatoTecnicoNome || "",
    contatoTecnicoTelefone: formulario.contatoTecnicoTelefone || "",
    contatoTecnicoCelular: formulario.contatoTecnicoCelular || "",
    contatoTecnicoEmail: formulario.contatoTecnicoEmail || "",
    valorEstimado: Number(formulario.valorEstimado || 0),
    valorDisponivel: parseNumero(formulario.valorDisponivel),
    ki: parseNumero(formulario.ki),
    kidoCusto: parseNumero(formulario.kidoCusto),
    porcentagemPIS: `${parseNumero(formulario.porcentagemPIS)}`,
    porcentagemCOFINS: `${parseNumero(formulario.porcentagemCOFINS)}`,
    porcentagemIIS: `${parseNumero(formulario.porcentagemIIS)}`,
    porcentagemICMSVenda: `${parseNumero(formulario.porcentagemICMSVenda)}`,
    porcentagemIPI: `${parseNumero(formulario.porcentagemIPI)}`,
    precoVenda_sIPI_cICMS: parseNumero(formulario.precoVenda_sIPI_cICMS),
    precoVenda_sIPI_sICMS: parseNumero(formulario.precoVenda_sIPI_sICMS),
    precoVenda_cISS: parseNumero(formulario.precoVenda_cISS),
    kv: formulario.kv,
    tipoDeEquipamento: formulario.tipoDeEquipamento || null,
    tipoDeEquipamentoSigla: formulario.tipoDeEquipamentoSigla || "",
    tipoDeEquipamentoDescricao: formulario.tipoDeEquipamentoDescricao || ""
  };
};